/// <reference types="./emoji.d.mts" />
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { px, rem } from "../../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $colors from "../../../ds/colors.mjs";
import { toList } from "../../../gleam.mjs";

export function emoji_container(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.position("absolute"),
      $css.width(px(0)),
      $css.height(px(0)),
      $css.left(rem(-9.0)),
      $css.z_index(99_999),
    ]),
  );
  return $html.div(_pipe, attrs, children);
}

export function emoji_picker_container(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.justify_content("center"),
      $css.align_items("center"),
      $css.border_radius(px(8)),
      $css.padding(px(8)),
      $css.width(rem(12.0)),
      $css.max_width(rem(12.0)),
      $css.height(rem(12.0)),
      $css.background($colors.light.grey_200),
    ]),
  );
  return $html.div(_pipe, attrs, children);
}

export function emoji_list(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.justify_content("space-between"),
      $css.align_items("center"),
      $css.flex_wrap("wrap"),
      $css.overflow_x("none"),
      $css.overflow_y("scroll"),
      $css.padding(px(8)),
      $css.gap(px(10)),
    ]),
  );
  return $html.div(_pipe, attrs, children);
}

export function emoji(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.line_height("24px"),
      $css.cursor("pointer"),
      $css.font_size(px(24)),
    ]),
  );
  return $html.div(_pipe, attrs, children);
}
